// extracted by mini-css-extract-plugin
var _1 = "badge___Szf0I";
var _2 = "label___lRahj";
export { _1 as "badge", _2 as "label" }
